import styled from 'styled-components';

export const SeoCard = styled.div`
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
  margin-top: 1rem;
`;

export const CardWrap = styled.div`
  padding: ${props => props.theme.spacing.custom(10)} ${props => props.theme.spacing.custom(20)} 0;
`;

export const CarrierLogo = styled.img`
  max-width: 100%;
  max-height: 25px;
  padding-right: ${props => props.theme.spacing.small};
`;

export const Time = styled.span`
  font-size: ${props => props.theme.font.custom(18)};
`;

export const DurBordr = styled.div`
  border-bottom: 2px solid #a7a3a3;
`;

export const BookButton = styled.button`
  background-color: #ff6d38;
  border-radius: 0.5rem;
  outline: none;
  padding: ${props => props.theme.spacing.custom(7)} 0;
  color: #ffffff;
  text-transform: ${props => (props.route ? 'capitalize' : 'uppercase')};
  border: none;
  font-weight: 500;
  font-size: ${props => props.theme.font.custom(14)};
  width: 85%;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #ffffff;
  }
  a.seoLink:hover {
    color: #ffffff;
  }
`;

export const Price = styled.div`
  font-size: ${props => props.theme.font.custom(20)};
`;
